import 'react-phone-number-input/style.css';
import styles from './style.module.css';
import PhoneInput from 'react-phone-number-input';
import { UseFormRegisterReturn } from 'react-hook-form';

interface IInputInternational {
  register?: UseFormRegisterReturn;
  onChange?: (value: string | undefined) => void;
  errors?: any;
  value?: any;
}

export function InputInternational({
  register,
  onChange,
  errors,
  value,
}: IInputInternational) {
  const handleChange = (phoneValue: string | undefined) => {
    if (onChange) {
      onChange(phoneValue);
    }
    // Call the registered onChange if it exists
    if (register?.onChange) {
      register.onChange({
        target: {
          value: phoneValue,
          name: register.name,
        },
        type: 'change',
      });
    }
  };

  return (
    <>
      <PhoneInput
        placeholder="Número de telefone"
        onChange={handleChange}
        className={styles.input}
        value={value}
        name={register?.name}
        ref={register?.ref}
      />
      <span className="tiny-text text-danger">
        {errors?.phone ? 'Obrigatório' : ''}
      </span>
    </>
  );
}
